module.exports = __webpack_public_path__ + "static/media/destech.44508ae8.svg";